export default "__VITE_ASSET__c0bjLz$K__"